export default __webpack_public_path__ + "static/media/romania-flag-icon.05840047.svg";